import React from 'react';

export default function AudioWaveMark({ animated = false, className = '' }) {
  return (
    <span className={`audio-wave-mark ${animated ? 'is-animated' : ''} ${className}`.trim()} aria-hidden="true">
      <span />
      <span />
      <span />
      <span />
      <span />
    </span>
  );
}
